<template>
  <div>
    <!-- Start toolbar search, orders, filter -->
    <div
      class="d-flex justify-content-between align-items-center mb-4 flex-wrap"
    >
      <p class="text-muted " v-if="preloader">Buscando...</p>
      <p
        class="text-muted "
        v-else-if="
          (proposalsLengthOfSearchInput == 0 && !preloader) ||
            (proposalsLengthOfDataBase == 0 && !preloader)
        "
      >
        Nenhuma proposta encontrada
      </p>
      <p
        class="text-muted "
        v-else-if="proposalsLengthOfSearchOfTag != 0 && !preloader"
      >
        Mostrando {{ proposalsLengthOfPagination }} de
        {{ proposalsLengthOfSearchOfTag }} proposta(s) filtrada(s) do total de
        {{ proposalsLengthOfDataBase }} {{ tab }}.
      </p>
      <p
        class="text-muted "
        v-else-if="
          proposalsLengthOfSearchInput != proposalsLengthOfDataBase &&
            !preloader
        "
      >
        Mostrando {{ proposalsLengthOfPagination }} de
        {{ proposalsLengthOfSearchInput }} proposta(s) buscada do total de
        {{ proposalsLengthOfDataBase }} {{ tab }}.
      </p>
      <p class="text-muted " v-else-if="!preloader">
        Mostrando {{ proposalsLengthOfPagination }} do total de
        {{ proposalsLengthOfDataBase }} {{ tab }} localizada(s).
      </p>

      <!--<div>
        <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="outline-primary"
        no-caret
        dropleft
        text="Filtre pela Etapa"
      >
        <b-dropdown-group id="dropdown-group-1" header="Epatas">
          <b-dropdown-item href="#">Avaliação de Risco</b-dropdown-item>
          <b-dropdown-item href="#">Engenharia</b-dropdown-item>
          <b-dropdown-item href="#">Formulários</b-dropdown-item>
          <b-dropdown-item href="#">FGTS</b-dropdown-item>
          <b-dropdown-item href="#">Dossiê</b-dropdown-item>
          <b-dropdown-item href="#">Escritura</b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
      <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="outline-primary"
        no-caret
        dropleft
        text="Filtre pela Situação"
        class="px-2"
      >
        <b-dropdown-group id="dropdown-group-1" header="Epatas">
          <b-dropdown-item href="#">Avaliação de Risco</b-dropdown-item>
          <b-dropdown-item href="#">Engenharia</b-dropdown-item>
          <b-dropdown-item href="#">Formulários</b-dropdown-item>
          <b-dropdown-item href="#">FGTS</b-dropdown-item>
          <b-dropdown-item href="#">Dossiê</b-dropdown-item>
          <b-dropdown-item href="#">Escritura</b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
      <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="outline-primary"
        no-caret
        dropleft
        text="Filtre pelo Status"
      >
        <b-dropdown-group id="dropdown-group-1" header="Epatas">
          <b-dropdown-item href="#">Avaliação de Risco</b-dropdown-item>
          <b-dropdown-item href="#">Engenharia</b-dropdown-item>
          <b-dropdown-item href="#">Formulários</b-dropdown-item>
          <b-dropdown-item href="#">FGTS</b-dropdown-item>
          <b-dropdown-item href="#">Dossiê</b-dropdown-item>
          <b-dropdown-item href="#">Escritura</b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
      <b-dropdown
        id="dropdown-1"
        size="sm"
        variant="outline-primary"
        no-caret
        dropleft
        class="pl-2"
        text="Adicione a Regra"
      >
        <b-dropdown-group id="dropdown-group-1" header="Epatas">
          <b-dropdown-item href="#">Avaliação de Risco</b-dropdown-item>
          <b-dropdown-item href="#">Engenharia</b-dropdown-item>
          <b-dropdown-item href="#">Formulários</b-dropdown-item>
          <b-dropdown-item href="#">FGTS</b-dropdown-item>
          <b-dropdown-item href="#">Dossiê</b-dropdown-item>
          <b-dropdown-item href="#">Escritura</b-dropdown-item>
        </b-dropdown-group>
      </b-dropdown>
      </div>-->
    </div>
    <div class="d-flex">
      <div @click="$emit('openModal')" class="mr-4" v-if="user.level == 'Admin'">
        <div class="d-flex justify-content-center notification-wrapper">
          <i class="notification-icon fa fa-clipboard-list"></i>
        </div>
        <div class="notification-label"></div>
      </div>
      <div
        v-if="atendimentoProposals.length && user.level == 'Admin'"
        @click="selectEmatendimentoProposals"
        class="mr-4"
      >
        <div class="d-flex justify-content-center notification-wrapper">
          <i class="notification-icon far fa-file"> </i>
          <b-badge class="proposalNumber" badge-pill variant="primary">{{
            atendimentoProposals.length
          }}</b-badge>
        </div>
        <div class="notification-label">Em atendimento</div>
      </div>
      <div v-if="newProposalsLength && user.level == 'Admin'" @click="selectNewProposals" class="mr-4">
        <div class="d-flex justify-content-center notification-wrapper">
          <i class="notification-icon far fa-bell"> </i>
          <b-badge class="proposalNumber" badge-pill variant="primary">{{
            newProposalsLength
          }}</b-badge>
        </div>
        <div class="notification-label">Nova Proposta</div>
      </div>
      <b-form-select
        size="sm"
        :options="tabs"
        value-field="index"
        text-field="title"
        v-model="selectedTab"
      ></b-form-select>
      <b-button-toolbar class="mt-2 mt-sm-0 ml-5">
        <b-button-group size="sm" class="mr-1">
          <b-button
            variant="outline-primary"
            title="Ordene as propostas por progresso, nome, data de criação ou data de atualização."
            v-b-toggle.collapse-1
            v-if="user.email == 'contato@parceirocaixa.com.br'"
          >
            <i
              class="fas fa-filter"
              v-b-tooltip.hover.bottomleft
              title="Filter"
            ></i>
          </b-button>
          <b-button
            variant="outline-primary"
            title="Ordene as propostas por progresso, nome, data de criação ou data de atualização."
            @click="toggleOrderBy"
          >
            <i
              class="fas fa-chart-line"
              v-if="condfigOrderBy_ == 'progressValue'"
              v-b-tooltip.hover.bottomleft
              title="Proposta ordenada por progresso"
            ></i>
            <i
              class="fas fa-font"
              v-if="condfigOrderBy_ == 'name'"
              v-b-tooltip.hover.bottomleft
              title="Proposta ordenada por nome"
            ></i>
            <i
              class="fas fa-clock"
              v-if="condfigOrderBy_ == 'created'"
              v-b-tooltip.hover.bottomleft
              title="Proposta ordenada por data de criação"
            ></i>
            <i
              class="fas fa-edit"
              v-if="condfigOrderBy_ == 'updated'"
              v-b-tooltip.hover.bottomleft
              title="Proposta ordenada por data de atualização"
            ></i>
          </b-button>
          <b-button
            variant="outline-primary"
            title="Classificar em crescente ou decrescente"
            @click="toggleOrder"
          >
            <i
              class="fas fa-sort-amount-up"
              v-if="configsOrder_ == 'asc'"
              v-b-tooltip.hover.bottomleft
              title="Ordenação Crescente das propostas"
            ></i>
            <i
              class="fas fa-sort-amount-down"
              v-if="configsOrder_ == 'desc'"
              v-b-tooltip.hover.bottomleft
              title="Ordenação Decrescente das propostas"
            ></i>
          </b-button>
          <b-button
            variant="outline-primary"
            title="Ordene as propostas por progresso, nome, data de criação ou data de atualização."
            @click="showAlert"
            v-if="user.email == 'contato@parceirocaixa.com.br'"
          >
            <i
              class="far fa-bell"
              v-b-tooltip.hover.bottomleft
              title="Propostas em Alerta"
            ></i>
          </b-button>
          <b-button
            variant="outline-primary"
            title="Ordene as propostas por progresso, nome, data de criação ou data de atualização."
            @click="$router.push('/dashboard')"
            v-if="user.email == 'contato@parceirocaixa.com.br'"
          >
            <i
              class="fa fa-chart-pie "
              v-b-tooltip.hover.bottomleft
              title="Gerar relatório"
            ></i>
          </b-button>
        </b-button-group>
      </b-button-toolbar>
    </div>
    <!-- End toolbar search, orders, filter -->
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "ProposalToolbarControls",
  props: [
    "tab",
    "tabReqName",
    "proposalsLengthOfDataBase",
    "proposalsLengthOfSearchInput",
    "proposalsLengthOfPagination",
    "proposalsLengthOfSearchOfTag",
    "configsOrderBy",
    "configsOrder",
    "tabIndex",
  ],
  data() {
    return {
      condfigOrderBy_: "progressValue",
      configsOrder_: "desc",
      pendingOptions: [
        "Risk Assessment",
        "Engineering",
        "Risk Assessment & Engineering",
      ],
      tabs: [
        {
          title: "Previstas",
          text: "Expected",
          reqName: "expected",
          content: "propostas previstas",
          isBlank: "proposta prevista",
          index: 0,
        },
        {
          title: "Todas",
          text: "All",
          reqName: "actived",
          content: "propostas",
          isBlank: "proposta ativa",
          index: 1,
        },
        {
          title: "Novas",
          text: "News",
          reqName: "steps.riskAssessment.actived",
          content: "propostas novas",
          isBlank: "nova proposta",
          index: 2,
        },
        {
          title: "Aprovadas",
          text: "Approved",
          reqName: "isApproved",
          content: "propostas aprovadas",
          isBlank: "proposta aprovada",
          index: 3,
        },
        {
          title: "Em andamento",
          text: "InProgress",
          reqName: "",
          content: "propostas em andamento",
          isBlank: "proposta em andamento",
          index: 4,
        },
        {
          title: "CICOB",
          text: "CICOB",
          reqName: "",
          content: "propostas na CICOB",
          isBlank: "proposta na CICOB",
          index: 5,
        },
        {
          title: "Contratadas",
          text: "Contracted",
          reqName: "",
          content: "propostas contratadas",
          isBlank: "proposta contrada",
          index: 6,
        },
        {
          title: "Com pendência(s)",
          text: "Pendings",
          reqName: "",
          content: "propostas com pendência(s)",
          isBlank: "proposta com pendência(s)",
          index: 7,
        },
        {
          title: "Reprovadas",
          text: "Disapproved",
          reqName: "",
          content: "propostas reprovadas",
          isBlank: "proposta reprovada",
          index: 8,
        },
        {
          title: "Descontinuadas",
          text: "Discontinued",
          reqName: "",
          content: "propostas descontinuadas",
          isBlank: "proposta descontinuada",
          index: 9,
        },
        {
          title: "Em atendimento",
          text: "Em atendimento",
          reqName: "",
          content: "",
          isBlank: "",
          index: 11,
        },
        // {
        //   title: "All by search",
        //   text: "All by search",
        //   reqName: "",
        //   content: "",
        //   isBlank: "",
        //   index: 10,
        // },
      ],
      selectedTab: {},
      // configs: {
      //   orderBy: "configsOrderBy",
      //   order: "configsOrder"
      // }
    };
  },
  watch: {
    configsOrderBy(newVal) {
      if (newVal) this.condfigOrderBy_ = newVal;
    },
    configsOrder(newVal) {
      if (newVal) this.configsOrder_ = newVal;
    },
    condfigOrderBy_proposal(newVal) {
      if (newVal) this.condfigOrderBy_ = newVal;
    },
    configsOrder_proposal(newVal) {
      if (newVal) this.configsOrder_ = newVal;
    },
    selectedTab(newVal) {
      this.$emit("updateIndex", newVal);
    },
    tabIndex(newVal) {
      this.selectedTab = newVal;
    },
  },
  mounted() {
    this.selectedTab = this.tabIndex;
    this.getAtendimentoProposals();
  },
  methods: {
    ...mapActions(["getProposals", "getAtendimentoProposals"]),
    toggleOrder() {
      this.configsOrder_ = this.configsOrder_ == "desc" ? "asc" : "desc";
      this.$emit("changeOrder", this.configsOrder_);
    },
    toggleOrderBy() {
      if (
        this.condfigOrderBy_ == "progressValue" ||
        this.condfigOrderBy_ == "name"
      ) {
        this.condfigOrderBy_ =
          this.condfigOrderBy_ == "progressValue" ? "name" : "created";
      } else {
        this.condfigOrderBy_ =
          this.condfigOrderBy_ == "created" ? "updated" : "progressValue";
      }
      this.$emit("changeOrderBy", this.condfigOrderBy_);
    },
    updatePendingOption(value) {
      this.getProposals({ tabIndex: 7, scroll: 1 });
    },
    showAlert() {
      this.$emit("setIndexToGlobal", {
        index: 10,
        type: "alert",
      });
    },
    selectNewProposals() {
      this.selectedTab = 2;
    },
    selectEmatendimentoProposals() {
      this.selectedTab = 11;
    },
  },
  computed: {
    ...mapState([
      "user",
      "condfigOrderBy_proposal",
      "configsOrder_proposal",
      "preloader",
      "newProposalsLength",
      "atendimentoProposals",
    ]),
    selectedPendingOption: {
      get() {
        return this.$store.state.selectedPendingOption;
      },
      set(value) {
        this.$store.commit("updatePendingOption", value);
      },
    },
    // proposalsList() {
    //   return _.orderBy(
    //     this.proposals,
    //     this.configs.orderBy,
    //     this.configs.order
    //   );
    // }
  },
};
</script>
<style scoped>
.notification-wrapper {
  position: relative;
  cursor: pointer;
}
.notification-icon {
  font-size: 24px;
}
.notification-label {
  font-size: 11px;
  white-space: nowrap;
}
.proposalNumber {
  position: absolute;
  font-size: 12px;
  left: 38px;
  top: -8px;
}
</style>
